var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box",class:{ bottomBarTransition: _vm.transform },attrs:{"id":_vm.id}},[_c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"moveCard":_vm.dragElement}},'component',_vm.props,false),_vm.func))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }